module.exports = __webpack_public_path__ + "img/img.065c39c2.jpg";